var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('Breadcrumb'),(_vm.isAdmin)?_c('SearchEngine',{staticClass:"noPrintable"}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }